import {
	SET_EDIT_STAY_PROPERTY,
} from '../actions/setEditStayProperty'

const initialState = {
}

export default function editStayPropertyReducer(state = initialState, action) {
	switch(action.type) {

		case SET_EDIT_STAY_PROPERTY:
			return {
				...state,
				activeHotelCode: action.payload,
			}

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/setEditStayPropertyReducer.js